"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertSeries = void 0;
const series_nonce_manager_model_1 = require("../model/series-nonce-manager.model");
function assertSeries(series) {
    if (series === series_nonce_manager_model_1.NonceSeriesV2._GaslessV3) {
        throw new TypeError('SeriesNonceManagerPredicateBuilder is unnecessary for Gasless. '
            + 'Use LimitOrderPredicateBuilder.');
    }
    if (series < 0) {
        throw new RangeError('Series should be valid value and greater than zero. Check the docs.');
    }
}
exports.assertSeries = assertSeries;
//# sourceMappingURL=series-nonce-manager.utils.js.map